import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthContainer from "./AuthContainer";
import CoreOtpInput from "../../core/inputs/CoreOtpInput";
import CorePassword from "../../core/inputs/CorePassword";
import { Box, Card, CardContent, Container, Grid, Link } from "@mui/material";
import CoreButton from "../../core/inputs/CoreButton";
import { useDispatch, useSelector } from "react-redux";
import { setNextUrl, setRouteReducer } from "../../store/actions/routeActions";
import { api_request } from "../../store/actions/commonAction";
import { API_METHOD_POST } from "../../config/constants";
import {
  OTP_SENT_ERROR,
  OTP_SENT_SUCCESS,
} from "../../store/types/communicationTypes";
import {
  RESET_PASSWORD_ERROR,
  RESET_PASSWORD_INITIATE_ERROR,
  RESET_PASSWORD_INITIATE_SUCCESS,
  RESET_PASSWORD_SUCCESS,
} from "../../store/types/authTypes";
import { setCommunicationReducer } from "../../store/actions/communicationActions";
import { setAuthReducer } from "../../store/actions/authActions";
import { LOGIN_ERROR, LOGIN_SUCCESS } from "../../store/types/authTypes";
import CoreButtonContainer from "../../core/layouts/CoreButtonContainer";
import CoreH4 from "../../core/dataDisplay/CoreH4";
import CoreTypographyBody1 from "../../core/dataDisplay/CoreTypographyBody1";
import CoreTypographySubtitle2 from "../../core/dataDisplay/CoreTypographySubtitle2";
import CoreContainedButton from "../../core/inputs/CoreContainedButton";
import { Formik } from "formik";
import {
  initiateForgotPasswordSchema,
  loginWithOtpSchema,
  resetPasswordSchema,
} from "../../formSchemas/authSchemas";
import CoreCaptcha from "../../core/inputs/CoreCaptcha";
import CoreInput from "../../core/inputs/CoreInput";
import CoreTextButton from "../../core/inputs/CoreTextButton";
import { theme } from "../../config/theme";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const captchaRef = useRef();

  const uid = useSelector((state) => state?.auth?.uid);
  const authError = useSelector((state) => state?.auth?.authError);
  const resetPasswordSuccess = useSelector(
    (state) => state?.auth?.resetPasswordSuccess,
  );
  const resetPasswordError = useSelector(
    (state) => state?.auth?.resetPasswordError,
  );
  const resetPasswordInitiateSuccess = useSelector(
    (state) => state?.auth?.resetPasswordInitiateSuccess,
  );
  const resetPasswordInitiateError = useSelector(
    (state) => state?.auth?.resetPasswordInitiateError,
  );

  const [email, setEmail] = useState(null);

  const onResetPasswordInitiate = (values, actions) => {
    const email = values?.email?.trim()?.toLowerCase();
    setEmail(email);
    dispatch(
      api_request(
        API_METHOD_POST,
        "/password/reset/initiate",
        {
          email: email,
        },
        null,
        null,
        RESET_PASSWORD_INITIATE_SUCCESS,
        RESET_PASSWORD_INITIATE_ERROR,
        false,
        false,
        false,
        true,
      ),
    );
  };

  const onResetPassword = (values, actions) => {
    dispatch(
      api_request(
        API_METHOD_POST,
        "/password/reset",
        {
          email: email,
          otp: values.otp,
          newPassword: values.password,
          captchaToken: values.captchaToken,
        },
        null,
        null,
        RESET_PASSWORD_SUCCESS,
        RESET_PASSWORD_ERROR,
        false,
        false,
        false,
        true,
      ),
    );
  };

  useEffect(() => {
    if (authError) {
      captchaRef?.current?.reset();
    }
  }, [authError]);

  useEffect(() => {
    if (resetPasswordSuccess) {
      alert("Password reset successful. Please login with new password.");
      dispatch(
        setAuthReducer({
          resetPasswordInitiateSuccess: false,
          resetPasswordSuccess: false,
        }),
      );
      navigate("/login");
      dispatch(setNextUrl("/login"));
    }
  }, [resetPasswordSuccess]);

  const onBack = () => {
    dispatch(setAuthReducer({ resetPasswordInitiateSuccess: false }));
    navigate("/login");
    dispatch(setNextUrl("/login"));
  };

  console.log("email", email);

  return !resetPasswordInitiateSuccess ? (
    <AuthContainer>
      <CoreH4
        style={{
          fontStyle: "italics",
          color: theme.palette.primary.main,
          alignSelf: "baseline",
          marginBottom: "16px",
        }}
      >
        Reset Password
      </CoreH4>
      <form style={{ width: "100%" }}>
        <Formik
          initialValues={{
            email: "",
          }}
          validationSchema={initiateForgotPasswordSchema}
          onSubmit={onResetPasswordInitiate}
        >
          {(formikProps) => (
            <>
              <CoreInput
                id="email"
                onBlur={formikProps.handleBlur("email")}
                onChange={formikProps.handleChange("email")}
                value={formikProps.values.email}
                formikProps={formikProps}
                autoFocus={false}
                label="Enter email or phone"
                autoComplete="off"
                inputProps={{ "aria-autocomplete": "none" }}
              />

              <CoreButtonContainer>
                <CoreContainedButton
                  fullWidth={true}
                  type="submit"
                  onClick={formikProps.handleSubmit}
                >
                  Send OTP
                </CoreContainedButton>
              </CoreButtonContainer>
              <Box style={{ display: "flex", justifyContent: "center" }}>
                <CoreTextButton onClick={onBack}>Cancel</CoreTextButton>
              </Box>
            </>
          )}
        </Formik>
      </form>
    </AuthContainer>
  ) : (
    <AuthContainer>
      <CoreH4
        style={{
          fontStyle: "italics",
          color: theme.palette.primary.main,
          alignSelf: "baseline",
          marginBottom: "16px",
        }}
      >
        Reset Password
      </CoreH4>
      <form style={{ width: "100%" }}>
        <Formik
          initialValues={{
            password: "",
            confirmPassword: "",
            otp: "",
            captchaToken: "",
          }}
          validationSchema={resetPasswordSchema}
          onSubmit={onResetPassword}
        >
          {(formikProps) => (
            <>
              <CorePassword
                id="password"
                onBlur={formikProps.handleBlur("password")}
                onChange={formikProps.handleChange("password")}
                value={formikProps.values.password}
                formikProps={formikProps}
                autoFocus={true}
                label="Enter password"
              />
              <CorePassword
                id="confirmPassword"
                onBlur={formikProps.handleBlur("confirmPassword")}
                onChange={formikProps.handleChange("confirmPassword")}
                value={formikProps.values.confirmPassword}
                formikProps={formikProps}
                autoFocus={true}
                label="Confirm password"
              />
              <CoreOtpInput
                id="otp"
                onBlur={formikProps.handleBlur("otp")}
                onChange={(value) => {
                  formikProps.setFieldValue("otp", value);
                }}
                value={formikProps.values.otp}
                formikProps={formikProps}
                autoFocus={true}
                label="Enter OTP"
              />
              <CoreCaptcha
                id="captchaToken"
                onChange={(val) => {
                  if (val) {
                    formikProps.setFieldValue("captchaToken", val);
                  }
                }}
                formikProps={formikProps}
                captchaRef={captchaRef}
              />
              <CoreButtonContainer>
                <CoreContainedButton
                  fullWidth={true}
                  type="submit"
                  onClick={formikProps.handleSubmit}
                >
                  Submit
                </CoreContainedButton>
              </CoreButtonContainer>
              <Box style={{ display: "flex", justifyContent: "center" }}>
                <CoreTextButton onClick={onBack}>Cancel</CoreTextButton>
              </Box>
            </>
          )}
        </Formik>
      </form>
    </AuthContainer>
  );
}
